import { useEffect, useState } from 'react'
import LocationService from '../api/Participantes/api.location'
import { Pais, Departamentos,  Comunas } from '../models/LocationsModels/locations.models'
import { reintentar } from '../utils/reintentar'

/** Intentos por lista antes de darla por perdida: esperan 1 s, 2 s y 3 s entre sí. */
const INTENTOS = 4;

/**
 * Pide una lista y la da por buena solo si trae algo. Países, departamentos y comunas nunca vienen
 * vacíos, así que una lista vacía —o una respuesta que no es lista— es un fallo y se reintenta.
 */
const obtenerLista = async <T>(obtener: () => Promise<T[]>, nombre: string): Promise<T[]> => {
    const lista = await obtener();
    if (!Array.isArray(lista) || lista.length === 0) {
        throw new Error(`El servicio de ubicación no devolvió ${nombre}`);
    }
    return lista;
}

/**
 * Carga las listas de ubicación de los formularios una vez, al abrirlos.
 *
 * Antes un solo fallo al abrir el formulario —la red, el token de invitado que aún no llegaba—
 * dejaba el selector en "No Data" hasta recargar la página. Ahora cada lista se reintenta sola.
 */
export const useLocations = () => {

    const [paises, setPaises] = useState<Pais[]>([]);
    const [departamentos, setDepartamentos] = useState<Departamentos[]>([])
    const [comunas, setComunas] = useState<Comunas[]>([]);

    useEffect(() => {
        let activo = true;

        const cargar = <T>(obtener: () => Promise<T[]>, nombre: string, guardar: (lista: T[]) => void) =>
            reintentar(() => obtenerLista(obtener, nombre), { intentos: INTENTOS, seguir: () => activo })
                .then((lista) => {
                    if (activo) guardar(lista);
                })
                .catch((error) => console.log(error));

        cargar(() => LocationService.obtenerPaises(), 'países', setPaises);
        cargar(() => LocationService.obtenerDepartamentos(), 'departamentos', (lista) =>
            setDepartamentos(lista.filter((x) => x.nombre !== 'OTRAS'))
        );
        cargar(() => LocationService.obtenerComunas(), 'comunas', setComunas);

        return () => {
            activo = false;
        }
    }, [])


    return {
        paises,
        departamentos,
        comunas
    }


}
